module.exports = __webpack_public_path__ + "assets/icons/analytics-logo.fd274225e4cc331c03c0039fc8949be7.svg";